<div *ngFor="let repo of repos" class="list-group">
  <a
    [href]="repo.html_url"
    target="_blank"
    class="list-group-item list-group-item-action"
    >{{ repo.name }}</a
  >
</div>
